import { IconWrapper, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--color-text-weak)';

export const DocumentIcon = ({
  textColor = DEFAULT_COLOR,
  size,
}: IconProps) => (
  <IconWrapper size={size}>
    <path d="M9 7L16.277 7L23 13.7658V25H9V7Z" fill={textColor} />
  </IconWrapper>
);
